   <div *ngIf="mainValue">
   <fusioncharts
    type="angulargauge"
    width="600"
    height="350"
    dataFormat="json"
    [dataSource]="dataSource"
   ></fusioncharts>
  </div>
